// Common
import React from 'react';

// Moment
import moment from 'moment';
import 'moment/locale/ru';

// Data
import ts_active from './data/ts_active';
import ts_archive from './data/ts_archive';

// Ant
import { 
    Icon,
    Avatar,
    Table,
    Typography,
    Radio,
    Select,
    Button,
    Modal,
    Input
} from 'antd';

const { Text } = Typography;
const { Option } = Select;
const confirm = Modal.confirm;
const Search = Input.Search;
const InputGroup = Input.Group;

moment.locale('ru');

class Excluded_TS extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            filtered_info: {
                year: [1990, 2100],
                places: [0, 100]
            },
            sorted_info: null,  
            search_text: '',          
            active: [],
            archive: [],
            excluded: [],
            selectedRowKeys: [],
            ts: {
                select: [],
                excluded_select: []
            },
            pagination: {
                pages: 3
            },
            types: {
                current: 'active'
            },
            position: {
                active: ''
            }
        }
        this.handle_exclude_ts = this.handle_exclude_ts.bind(this);
    }

    componentDidMount() {

        // Активные/архивные пользователи
        this.setState((state, props) => ({
            ...state,
            active: ts_active,
            archive: ts_archive,
            ts: {
                ...state.ts,
                select: ts_active
            }
        }))

    }

    componentDidUpdate(prevProps, prevState) {

        console.log(this.state);

        if(this.state.active !== prevState.active || this.state.archive !== prevState.archive) {

            let active = this.state.active,
                archive = this.state.archive,
                ts_excluded = [];

                active.forEach((item, index) => {
                    if(item.excluded) {
                        ts_excluded.push(item);
                    }
                });

                archive.forEach((item, index) => {
                    if(item.excluded) {
                        ts_excluded.push(item);
                    }
                });
                

            this.setState((state, props) => ({
                ...state,
                excluded: ts_excluded
            }));

            this.props.handle_exclude_ts(ts_excluded);

        }

    }

    // Работа с таблицей
    change_events_table = (pagination, filters, sorter) => {
        this.setState((state, props) => ({
            filtered_info: filters
        }));
    };

    render_ts_table(){

        const { selectedRowKeys } = this.state;
        let { filtered_info } = this.state;
        // let { sorted_info, filtered_info } = this.state;
        // sorted_info = sorted_info || {};
        filtered_info = filtered_info || {};

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState((state, props) => ({
                    selectedRowKeys,
                    ts: {
                        ...state.ts,
                        excluded_select: selectedRows
                    }
                }))
            }
        };
        
        const { pages } = this.state.pagination;
        const ts = this.state.ts.select;


        let columns = [
            {
                title: '',
                dataIndex: 'photo',
                key: 'photo',
                width: 65,
                render: fio => (
                    <Avatar shape="square" size="large" icon="user" />
                )
            },{
                title: 'Наименование',
                dataIndex: 'auto',
                key: 'auto',
                render: auto => (
                    <span>{auto.name} <br/><Text type="secondary">{auto.type}</Text></span>
                ),
                sorter: (a, b) => { return a.auto.name.localeCompare(b.auto.name)}
            },{
                title: 'Год',
                dataIndex: 'year',
                key: 'year',
                render: year => (
                    <span>{year}</span>
                ),
                filteredValue: filtered_info.year || null,
                onFilter: (value, record) => {
                    return filtered_info.year[0] <= parseInt(record.year) && filtered_info.year[1] >= parseInt(record.year)
                },
                sorter: (a, b) => { return a.year.localeCompare(b.year)}
            },{
                title: 'Рег. знак',
                dataIndex: 'reg_number',
                key: 'reg_number',
                render: reg_number => (
                    <span>{reg_number}</span>
                ),
                sorter: (a, b) => { return a.reg_number.localeCompare(b.reg_number)}
            },{
                title: 'Мест',
                dataIndex: 'places',
                key: 'places',
                render: places => (
                    <span>{places}</span>
                ),
                filteredValue: filtered_info.places || null,
                onFilter: (value, record) => {
                    return filtered_info.places[0] <= parseInt(record.places) && filtered_info.places[1] >= parseInt(record.places)
                },
                sorter: (a, b) => { return a.places.localeCompare(b.places)}
            },{
                title: 'Ставка',
                dataIndex: 'price',
                key: 'price',
                render: price => (
                    <span>{price.minute.count}&nbsp;{price.minute.unit} <br/><Text type="secondary">{price.hour.count}&nbsp;{price.hour.unit}</Text></span>
                ),
                sorter: (a, b) => { return a.price.minute.count.localeCompare(b.price.minute.count)}
            },{
                title: 'Дата ближ. подачи',
                dataIndex: 'date_application',
                key: 'date_application',
                render: date_application => (
                    <span>
                        {moment(parseInt(date_application)).format('DD.MM.YYYY HH:mm')} <br/>
                        <Text type="secondary">{moment(parseInt(date_application)).fromNow()}</Text>
                    </span>
                ),
                sorter: (a, b) => { return a.date_application.localeCompare(b.date_application)}
            }
        ];

        return (
            <div className="excluded-ts__table">
                <Table
                    dataSource={ts}
                    pagination={{
                        pageSize: pages
                    }}
                    rowSelection={rowSelection}
                    rowClassName={(record, index) => ({
                        index,
                        row_excluded: record.excluded && this.state.types.current !== 'excluded'
                      })}
                    rowKey="key"
                    columns={columns}
                    onChange={this.change_events_table}>
                </Table>
            </div>
        )
    }

    // Выбор активных/архивных пользователей
    handle_types_ts = e => {
        this.setState((state, props) => ({
            filtered_info: null,
            types: {
                current: e.target.value
            },
            ts: {
                ...state.ts,
                select: this.state[e.target.value]
            },
            position: {
                active: ''
            }
        }));
    }

    // Выбор кол-во отображаемыъ элементов в таблице
    change_ts_size(e){
        this.setState((state, props) => ({
            pagination: {
                pages: e
            }
        }));
    }

    // Вывод кол-во отображаемых строк
    render_ts_pages(){
        return (
            <div className="excluded-ts__pages">
                <span className="excluded-ts__pages-title">Показать на странице</span>
                <Select defaultValue={this.state.pagination.pages} style={{ width: 80 }} onChange={e => this.change_ts_size(e)}>
                    <Option value="3">3</Option>
                    <Option value="5">5</Option>
                    <Option value="10">10</Option>
                </Select>
            </div>
        )
    }

    // Сбросить выбранные ТС
    reset_excluded_ts_select = () => {
        this.setState((state, props) => ({
            selectedRowKeys: [],
            ts: {
                ...state.ts,
                excluded_select: []
            }
        }));
    }

    // Исключить ТС
    handle_exclude_ts = (e) => {

        let ts_active = this.state.active,
            ts_archive = this.state.archive,
            ts_excluded = this.state.ts.excluded_select,
            ts_active_new = [],
            ts_archive_new = [];

            ts_excluded.forEach((item, index) => {
                ts_active.forEach((el, index) => {
                    if(item.key === el.key){
                        el.excluded = true;
                    }
                    let state_find = false;
                    ts_active_new.forEach((it, index) => { 
                        if(it.key === el.key){
                            state_find = true;
                        }
                    });
                    if(!state_find){
                        ts_active_new.push(el);
                    }
                });
                ts_archive.forEach((el, index) => {
                    if(item.key === el.key){
                        el.excluded = true;
                    }
                    let state_find = false;
                    ts_archive_new.forEach((it, index) => { 
                        if(it.key === el.key){
                            state_find = true;
                        }
                    });
                    if(!state_find){
                        ts_archive_new.push(el);
                    }
                });
            });

            this.setState((state, props) => ({
                active: ts_active_new,
                archive: ts_archive_new
            }));

            this.hide_modal();
            this.reset_excluded_ts_select();

    }

    // Вернуть из исключенных
    return_exclude_ts = () => {

        let ts_active = this.state.active,
            ts_archive = this.state.archive,
            ts_excluded = this.state.ts.excluded_select,
            ts_active_new = [],
            ts_archive_new = [];

            ts_excluded.forEach((item, index) => {
                ts_active.forEach((el, index) => {
                    if(item.key === el.key){
                        el.excluded = false;
                    }
                    let state_find = false;
                    ts_active_new.forEach((it, index) => { 
                        if(it.key === el.key){
                            state_find = true;
                        }
                    });
                    if(!state_find){
                        ts_active_new.push(el);
                    }
                });
                ts_archive.forEach((el, index) => {
                    if(item.key === el.key){
                        el.excluded = false;
                    }
                    let state_find = false;
                    ts_archive_new.forEach((it, index) => { 
                        if(it.key === el.key){
                            state_find = true;
                        }
                    });
                    if(!state_find){
                        ts_archive_new.push(el);
                    }
                });
            });

            this.setState((state, props) => ({
                active: ts_active_new,
                archive: ts_archive_new
            }));

            this.hide_modal();
            this.reset_excluded_ts_select();

    }

    show_confirm_exclude_ts = () => {
        confirm({
            title: 'Внимание',
            content: 'Вы действительно хотите исключить выбранные ТС ('+this.state.ts.excluded_select.length+') для данного водителя?',
            okText: "Исключить",
            cancelText: "Отмена",
            onOk: this.handle_exclude_ts,
            onCancel: this.hide_modal,
            className: 'confirm-gray',
            width: 432,
            cancelButtonProps: {
                type: 'primary',
                ghost: true
            }
        });
    }

    show_return_exclude_ts = () => {
        confirm({
            title: 'Внимание',
            content: 'Вы действительно хотите убрать из исключенных выбранные ТС ('+this.state.ts.excluded_select.length+') для данного водителя?',
            okText: "Убрать из исключенных",
            cancelText: "Отмена",
            onOk: this.return_exclude_ts,
            onCancel: this.hide_modal,
            className: 'confirm-gray',
            width: 432,
            cancelButtonProps: {
                type: 'primary',
                ghost: true
            }
        });
    }

    hide_modal = () => {
        Modal.destroyAll();
    }

    // Обработка поиска по таблице при вводе
    handle_search_employees_change = e => {
        const { value } = e.target;
        this.setState((state, props) => ({
            search_text: value
        }))
    }

    // Обработка поиска по таблице при клике
    handle_search_employees_search = e => {

        let types_current = this.state.types.current,
            data = this.state[types_current],
            searchText = this.state.search_text,
            reg = new RegExp(searchText, 'gi');

        this.setState((state, props) => ({
            filtered_search: !!searchText,
            ts: {
                ...state.ts,
                select: data.map((record) => {
                    const match = record.auto.name.match(reg);
                    if (!match) {
                        return null;
                    }
                    return {
                        ...record,
                        name: (
                            <span>
                            {record.auto.name.split(reg).map((text, i) => (
                                i > 0 ? [<span>{match[0]}</span>, text] : text
                            ))}
                            </span>
                        ),
                    };
                }).filter(record => !!record),
            }
        }));

    }

    // Фильтр
    handle_filter_year_min = value => {
        let year = this.state.filtered_info.year;
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                year: [parseInt(value), year[1]]
            }
        }));
    }

    handle_filter_year_max = (value) => {
        let year = this.state.filtered_info.year;
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                year: [year[0], parseInt(value)]
            }
        }));
    }

    handle_filter_places_min = e => {
        let places = this.state.filtered_info.places;
        let { value } = e.target;
        if(!value.length){
            value = 0;
        }
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                places: [parseInt(value), places[1]]
            }
        }));
    }

    handle_filter_places_max = e => {
        let places = this.state.filtered_info.places;
        let { value } = e.target;
        if(!value.length){
            value = 100;
        }
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                places: [places[0], parseInt(value)]
            }
        }));
    }

    render(){
        let count_active = this.state.active && this.state.active.length,
            count_archive = this.state.archive && this.state.archive.length,
            count_excluded = this.state.excluded && this.state.excluded.length,
            excluded = this.state.ts.excluded_select,
            excluded_ts_select = 'excluded-ts__select';

            if(excluded && excluded.length){
                excluded_ts_select = 'excluded-ts__select active';
            }

        return (
            <div className="excluded-ts">
                <div className="excluded-ts__header">
                    <div className="excluded-ts__types">
                        <Radio.Group defaultValue="active" size="large" onChange={this.handle_types_ts}>
                            <Radio.Button className={(this.state.types.current === 'active' && 'button button_active') || 'button'} key="0" value="active" disabled={!count_active}>Активные:  {count_active}</Radio.Button>
                            <Radio.Button className={(this.state.types.current === 'archive' && 'button button_active') || 'button'} key="1" value="archive" disabled={!count_archive}>Архив: {count_archive}</Radio.Button>
                            <Radio.Button className={(this.state.types.current === 'excluded' && 'button button_right button_active') || 'button button_right'} key="2" value="excluded" disabled={!count_excluded}>Исключенные: {count_excluded}</Radio.Button>
                        </Radio.Group>
                    </div>
                </div>
                <div className="excluded-ts__wrap">
                    <div className="excluded-ts__header">
                        <div className="excluded-ts__search">
                            <Search
                                placeholder="Поиск по ТС"
                                onChange={this.handle_search_employees_change}
                                onSearch={this.handle_search_employees_search}
                                style={{ width: 224 }}
                            />
                        </div>
                        <div className="clear"></div>
                        <div className="excluded-ts__range">
                            Пассажировместимость:
                            <InputGroup compact style={{ width: 224 }}>
                                <Input style={{ width: '50%' }} onChange={this.handle_filter_places_min} placeholder="от" />
                                <Input style={{ width: '50%' }} onChange={this.handle_filter_places_max} placeholder="до" />
                            </InputGroup>
                        </div>
                        <div className="excluded-ts__range">
                            Год выпуска:
                            <InputGroup compact style={{ width: 224 }}>
                                <Select style={{ width: '50%' }} placeholder="от" onChange={this.handle_filter_year_min}>
                                    <Option value="1995">1995</Option>
                                    <Option value="2000">2000</Option>
                                    <Option value="2005">2005</Option>
                                    <Option value="2010">2010</Option>
                                    <Option value="2015">2015</Option>
                                    <Option value="2020">2020</Option>
                                </Select>
                                <Select style={{ width: '50%' }} placeholder="до" onChange={this.handle_filter_year_max}>
                                    <Option value="1995">1995</Option>
                                    <Option value="2000">2000</Option>
                                    <Option value="2005">2005</Option>
                                    <Option value="2010">2010</Option>
                                    <Option value="2015">2015</Option>
                                    <Option value="2020">2020</Option>
                                </Select>
                            </InputGroup>
                        </div>
                    </div>
                    {this.render_ts_table()}
                    {this.render_ts_pages()}
                </div>
                <div className="excluded-ts__footer">
                    <div className={excluded_ts_select}>
                        <div className="excluded-ts__select-count">
                            {excluded && excluded.length > 0 && (<Icon type="info" />)} Выбрано ТС: {excluded && excluded.length}
                        </div>
                        {excluded && excluded.length > 0 && <Button onClick={this.reset_excluded_ts_select} className="excluded-ts__reset" type="link">Сбросить</Button>}
                    </div>
                    <Button 
                        className="excluded-ts__confirm" 
                        type="primary" 
                        onClick={(this.state.types.current !== 'excluded' && this.show_confirm_exclude_ts) || this.show_return_exclude_ts} 
                        disabled={!excluded.length}>{(this.state.types.current !== 'excluded' && 'Исключить выбранные ТС') || 'Убрать из исключенных'}</Button>
                </div>
            </div>
        )
    }
}

export default Excluded_TS;